import axios from "axios";
import Store from "../redux/store";
import { logout } from "../redux/loginSlice";

const apiRequest = async ({
  method,
  endpoint,
  headers,
  data,
  params,
  maxRedirects,
}) => {
  try {
    return await axios({
      method,
      url: `${process.env.REACT_APP_API_URL}/${endpoint}`,
      headers,
      data,
      params,
      maxRedirects,
    });
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Handle logout here
      Store.dispatch(logout());
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
    throw error;
  }
};

export default apiRequest;
